import { CROPPED_THUMBNAIL, LIMIT_OF_CHARACTERS, USER_ROLE } from '~/shared/constants';
import { getValidatePhone, validate, validator } from '~/shared/helpers/validation-helpers';

const getUserProfileFormConfig = ({
  t,
  initialValues,
  isFooterReverse,
  isFixedActions,
  changeStateOfConfirmRemovingModal,
}: {
  t: (key: string, options: { ns: string[] }) => string;
}) => {
  const validation = validator({ t });
  const shouldShowTelegramSettings = initialValues?.role === USER_ROLE.STUDENT && initialValues?.telegram?.isConnected;

  return {
    name: 'userProfile',
    pattern: 'basicFormPattern',
    initialValues,
    isFooterReverse,
    isFixedActions,
    position0: {
      title: t('text.edit-user-profile'),
    },
    position1: {
      formFields: [
        {
          name: 'login',
          label: t('field.login.title'),
          required: true,
          validate: validate([
            validation.required,
            validation.isAlphanumeric.bind(null, 'en-US'),
            validation.isInRange.bind(null, {
              min: LIMIT_OF_CHARACTERS.LOGIN.MIN,
              max: LIMIT_OF_CHARACTERS.LOGIN.MAX,
            }),
          ]),
          type: 'text',
        },
        {
          name: 'imageCropModal',
          label: t('field.avatar.title'),
          type: 'image-crop-modal',
          config: {
            croppedThumbnailSize: {
              width: CROPPED_THUMBNAIL.AVATAR.WIDTH,
              aspect: CROPPED_THUMBNAIL.AVATAR.ASPECT,
            },
            formFields: [
              {
                name: 'avatar',
                label: t('field.thumbnail-image.title'),
                type: 'image',
                config: {
                  changeStateOfConfirmRemovingModal,
                },
              },
            ],
          },
        },
        {
          name: 'phone',
          label: t('field.phone.title'),
          placeholder: t('field.your-phone-number.placeholder'),
          type: 'phone-input',
          config: {
            enableSearch: true,
            getValidate: getValidatePhone(initialValues, validation),
          },
        },
      ],
    },
    position2: {
      formFields: [
        {
          name: 'firstName',
          label: t('field.first-name.title'),
          required: true,
          validate: validate([
            validation.required,
            validation.isInRange.bind(null, {
              min: LIMIT_OF_CHARACTERS.FIRST_NAME.MIN,
              max: LIMIT_OF_CHARACTERS.FIRST_NAME.MAX,
            }),
          ]),
          type: 'text',
        },
        {
          name: 'lastName',
          label: t('field.last-name.title'),
          type: 'text',
        },
      ],
    },
    actions: {
      buttons: [
        {
          name: 'submit',
          htmlType: 'submit',
          className: 'call-to-action-button--purple',
          size: 'large',
          buttonName: t('button.save'),
          config: {
            isBlock: true,
          },
        },
      ],
    },
  };
};

export default getUserProfileFormConfig;
